(function () {
  addGlobalEventListener('click', '.js-product-quick-view', function (e) {
    const qv = qs('quick-view');
    const product = getClosest('.product-card', e);

    qv.load(product.dataset.url);
  });
})();

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.template = qs('#quick-view-template');
    this.mediaTemplate = qs('#quick-view__media-template');
    this.colorTemplate = qs('#quick-view__color-template');
    this.sizeTemplate = qs('#quick-view__size-template');
    this.container = qs('.quick-view__container');

    this.init();
  }

  init() {
    addGlobalEventListener(
      'click',
      '.js-quick-view__close',
      this.hide.bind(this)
    );

    addGlobalEventListener(
      'click',
      '.js-quick-view__color-item',
      this.selectColor.bind(this)
    );

    addGlobalEventListener(
      'click',
      '.js-quick-view__size-item',
      this.selectSize.bind(this)
    );

    addGlobalEventListener('click', '.js-quick-view__quantity-down', () => {
      let valueEl = qs('.js-quick-view__quantity-value input');

      if (+valueEl.value > 0) {
        valueEl.value = +valueEl.value - 1;
      }
    });

    addGlobalEventListener('click', '.js-quick-view__quantity-up', () => {
      let valueEl = qs('.js-quick-view__quantity-value input');
      valueEl.value = +valueEl.value + 1;
    });

    addGlobalEventListener(
      'click',
      '.js-quick-view__atc',
      this.addToCart.bind(this)
    );
  }

  load(url) {
    fetch(`${url}.js`)
      .then((res) => res.json())
      .then((product) => {
        this.product = product;
        this.render(product);
        this.show();
      });
  }

  selectColor(color) {
    let size = qs('.js-quick-view__size-item.quick-view__size-item--active');

    this.variant = this.product.variants.find((variant) => {
      return (
        variant.options.includes(color.dataset.value) &&
        variant.options.includes(size.dataset.value)
      );
    });

    this.render(this.product, this.variant);
  }

  selectSize(size) {
    let color = qs('.js-quick-view__color-item.quick-view__color-item--active');

    this.variant = this.product.variants.find((variant) => {
      return (
        variant.options.includes(color.dataset.value) &&
        variant.options.includes(size.dataset.value)
      );
    });

    this.render(this.product, this.variant);
  }

  addToCart() {
    let valueEl = qs('.js-quick-view__quantity-value input');

    window.Shopify.theme.cart
      .addItem(this.variant.id, +valueEl.value)
      .then((res) => {
        this.hide();
        window.Shopify.theme.miniCart.show();
      });
  }

  render(product, variant) {
    if (!variant) {
      variant = product.variants[0];
    }

    this.container.innerHTML = interpolate(this.template.innerHTML, {
      product,
      variant,
      title:
        product.variants.length > 1
          ? `${product.title} - ${variant.title}`
          : product.title,
    });

    this.renderMedia(product, variant);
    this.renderColor(product, variant);
    this.renderSize(product, variant);
  }

  renderMedia(product, variant) {
    let mediaHTML = interpolate(
      this.mediaTemplate.innerHTML,
      variant.featured_image
    );

    qs('.js-quick-view__media-inner', this.container).innerHTML = mediaHTML;

    new Swiper('.js-quick-view__media', {
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  renderColor(product, variant) {
    let colorHTML = '';
    let hasColor = false;
    product.options.forEach((option) => {
      if (option.name.toLowerCase() === 'color') {
        hasColor = true;
        option.values.forEach((color) => {
          colorHTML += interpolate(this.colorTemplate.innerHTML, {
            color,
            selected: variant.options.includes(color),
          });
        });
      }
    });

    qs('.js-quick-view__color-inner', this.container).innerHTML = colorHTML;

    if (!hasColor) {
      qs('.js-quick-view__color').style.display = 'none';
    }
  }

  renderSize(product, variant) {
    let sizeHTML = '';
    let hasSize = false;
    product.options.forEach((option) => {
      if (option.name.toLowerCase() === 'size') {
        hasSize = true;
        option.values.forEach((size) => {
          sizeHTML += interpolate(this.sizeTemplate.innerHTML, {
            size,
            selected: variant.options.includes(size),
          });
        });
      }
    });

    qs('.js-quick-view__size-inner', this.container).innerHTML = sizeHTML;

    if (!hasSize) {
      qs('.js-quick-view__size').style.display = 'none';
    }
  }

  show() {
    scrollLock();
    this.classList.remove('quick-view--hidden');
  }

  hide() {
    scrollLock(false);
    this.classList.add('quick-view--hidden');
  }
}

customElements.define('quick-view', QuickView);
